/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncRulesCreateComponent, AsyncRulesEditComponent, AsyncRulesListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from 'react-i18next';
import {config} from '../config';

const Rules: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('rules.name')}`}</title>
                <meta name="description" content="Rules" />
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}`}
                    component={AsyncRulesListComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/create`}
                    component={AsyncRulesCreateComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/:id([0-9]+)`}
                    component={AsyncRulesEditComponent}
                />
                <Redirect
                    exact
                    from={`${match?.url}/`}
                    to={`${match?.url}`}
                />
            </Switch>
        </div>
    );
};

export default Rules;
